export default __webpack_public_path__ + "static/beige-nr-desserto-sand-531ea89664b8615f346cb68db91f0445.jpg";